import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';

import { ReactComponent as MarkSVG } from '../../../../assets/icons/mark.svg';

import './Checkbox.scss';

export enum CheckboxSize {
  medium = 'md',
  large = 'lg',
}

export interface CheckboxProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  checked?: boolean;
  size?: CheckboxSize;
  onChange?;
}

const Checkbox = ({
  className,
  checked,
  size = CheckboxSize.medium,
  onChange,
  ...props
}: CheckboxProps) => {
  return (
    <label
      className={classnames('checkbox', `checkbox_size_${size}`, className)}
      {...props}
    >
      <input
        className="checkbox__input"
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <div className="checkbox__content">
        <MarkSVG />
      </div>
    </label>
  );
};

export default Checkbox;
